// src/components/dashboard/BackgroundGrid.tsx
import React, { memo } from "react";

export const BackgroundGrid = memo(() => (
  <div className="fixed inset-0 pointer-events-none z-0">
    <div
      className="absolute inset-0 opacity-10"
      style={{
        backgroundImage: `linear-gradient(#444 1px, transparent 1px), linear-gradient(90deg, #444 1px, transparent 1px)`,
        backgroundSize: "40px 40px",
        transform: "perspective(1000px) rotateX(60deg) scale(2.5)",
        transformOrigin: "center",
      }}
    />
  </div>
));

BackgroundGrid.displayName = "BackgroundGrid";
